import type { IConfig } from './schemas/config';

let cfg: IConfig = {} as IConfig;
export async function loadRuntimeConfig() {
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (res.ok) cfg = await res.json();
  } catch {
    /* noop */
  }
}
export function getConfig(): IConfig {
  return cfg;
}
